// extracted by mini-css-extract-plugin
export default {"notifications":"_5DDColVZ","error":"_5DTSS5fS","info":"_5DMOlYhy","success":"_5DJCOBIX","warning":"_5DRqjrwO"};